import React from 'react';
import { CompanyAdminMeta, Group } from '@dispatch/shared/types';
import { AdminDashboardTable } from './AdminDashboardTable';
import { actionsColumn, clickToCopy, textColumn } from '@dispatch/web/ui';
import {
  GridActionsCellItem,
  GridColDef,
  GridRowParams,
} from '@mui/x-data-grid';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { handleModalOpen, onClick } from './helpers';

export const GroupAdmin = ({
  groups = [],
  modalState,
  isLoading,
}: {
  groups?: Group[];
  modalState?: {
    meta: CompanyAdminMeta;
    setmeta: React.Dispatch<CompanyAdminMeta>;
  };
  isLoading?: boolean;
}) => {
  const handleClick = React.useCallback(
    (params: GridRowParams) => onClick('addGroup', params, modalState),
    [modalState?.meta.addTeam]
  );

  const handleDelete = React.useCallback(
    (params: GridRowParams & { type?: string }) => {
      params.type = 'group';
      onClick('delete', params, modalState);
    },
    [modalState?.meta]
  );

  const columns: GridColDef[] = [
    clickToCopy({
      field: 'integrationGUID',
      headerName: 'ID',
    }),
    textColumn({
      field: 'name',
      headerName: 'Name',
    }),
    actionsColumn((params: GridRowParams) => [
      <GridActionsCellItem
        key="edit"
        icon={<EditIcon />}
        label="EDIT"
        onClick={() => {
          handleClick(params);
        }}
        showInMenu
      />,
      <GridActionsCellItem
        key="delete"
        icon={<DeleteIcon />}
        label="DELETE"
        onClick={() => {
          handleDelete(params);
        }}
        showInMenu
      />,
    ]),
  ];

  return (
    <AdminDashboardTable<Group>
      isLoading={isLoading}
      columns={columns}
      data={groups}
      type="Group"
      identifier="integrationGUID"
      handleClick={() => handleModalOpen('addGroup', modalState)}
    />
  );
};
